import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function resolveImg(url) {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  return `${BACKEND_URL}${url}`;
}

// Same-origin URL for <canvas> use: cross-origin remote images are routed through
// the backend proxy so they can be drawn/exported without CORS tainting.
export function proxyImg(url) {
  if (!url) return "";
  if (url.startsWith("data:")) return url;
  const abs = url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
  try {
    if (new URL(abs).origin === new URL(BACKEND_URL).origin) return abs;
  } catch { return abs; }
  return `${API}/img-proxy?url=${encodeURIComponent(abs)}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
